// MODULES
import React from "react";

// COMPONENTS
import EditableField from "@routes/Cob/components/EditableField/EditableField";
import FieldsCollection from "@components/FieldsCollection/FieldsCollection";
import OptionsList from "@routes/Cob/components/OptionsList/OptionsList";

// HELPERS
import {createClassName} from "@helpers/utils";
import Select from "../../../../../../../../components/Select/Select";
import Validator from "../../../../../../../../classes/Validator";

export default class Collection extends React.PureComponent {

	render() {
		const {props} = this;
		const {index, fields, validFields, onFieldChange, onFieldBlur, onOptionsListChange, availableBanks} = props;
		const classes = createClassName("Cob-Questionnaire-Collection", {
			"first": index === 0,
		});

		/**
		 * Set up the dropdown with selectable banks.
		 */
		let availableBankOptions = [];
		for (const bankName in availableBanks) {
			if (bankName === 'length' || !availableBanks.hasOwnProperty(bankName)) continue;
			availableBankOptions.push({
				label: bankName,
				value: bankName
			});
		}

		availableBankOptions.push({
			label: "Övriga",
			value: "-"
		});

		let selectedBankIndex = -1;

		if (fields.customer_account_bank && fields.customer_account_bank.length > 0) {
			let bankFoundInList = false;
			for (const bankName in availableBanks) {
				if (bankName === 'length' || !availableBanks.hasOwnProperty(bankName)) {
					continue;
				}
				selectedBankIndex++;
				if (bankName === fields.customer_account_bank) {
					bankFoundInList = true;
					break;
				}
			}

			if (!bankFoundInList && fields.customer_account_bank === '-') {
				selectedBankIndex++;
			}
		}

		return (
			<div className={classes}>
				<h3>Autogiromedgivande / Föranmält konto</h3>

				<div className="description">
					<p>Undertecknad (”betalaren”), medger att betalning får göras genom uttag från angivet konto eller
						av betalaren senare angivet Konto, på begäran av angiven betalningsmottagare för betalning till
						denne på viss dag (”förfallodagen”) via Autogiro. Betalaren medger att insättning och uttag från
						angivet konto eller av betalaren föranmält konto får göras på begäran av betalaren. Betalaren
						samtycker till att behandling av personuppgifter som lämnats i detta medgivande behandlas av
						betalarens betaltjänstleverantör, betalningsmottagaren, betalningsmottagarens
						betaltjänstleverantör och Bankgirocentralen BGC AB för administration av tjänsten.
						Personuppgiftsansvariga för denna personuppgiftsbehandling är betalarens betaltjänstleverantör,
						betalningsmottagaren samt betalningsmottagarens betaltjänstleverantör. Betalaren kan när som
						helst begära att få tillgång till eller rättelse av personuppgifterna genom att kontakta
						betalarens betaltjänstleverantör. Ytterligare information om behandling av personuppgifter i
						samband med betalningar kan finnas i villkoren för kontot och i avtalet med
						betalningsmottagaren. Betalaren kan när som helst återkalla sitt samtycke, vilket medför att
						tjänsten i sin helhet avslutas.</p>
				</div>

				<FieldsCollection
					fields={[
						{
							render: (
								<OptionsList
									type="radio"
									orientation="horizontal"
									name="customer_autogiro"
									description="Jag ger mitt medgivande till betalning via autogiro"
									options={fields.customer_autogiro.options}
									onChange={onOptionsListChange}
								/>
							),
						},
					]}
				/>

				{!!fields.customer_autogiro.options[0].checked && (
					<React.Fragment>
						<div style={{width: "100%", flexDirection: "row", margin: "15px 0 5px 0"}}>
							<Select
								name="customer_account_bank"
								label="Bank"
								style={{width: "45%", marginRight: "10px"}}
								selectedIndex={selectedBankIndex}
								options={availableBankOptions}
								onChange={this._onSelectBankChange}
							/>


							{fields.customer_account_bank === '-' && (
								<React.Fragment>
									<EditableField
										name="customer_account_bank_custom"
										label="Bank"
										style={{width: "45%"}}
										value={fields.customer_account_bank_custom || ""}
										valid={validFields.customer_account_bank_custom}
										onChange={onFieldChange}
										onBlur={onFieldBlur}
									/>
									<input type="hidden" name="customer_account_bank"
										   value={fields.customer_account_bank_custom}/>
								</React.Fragment>
							)}

							{fields.customer_account_bank !== '-' && (
								<input type="hidden" name="customer_account_bank_custom" value=""/>
							)}
						</div>

						{fields.customer_account_bank === 'Swedbank' && (
							<p style={{background: "#FFFFD5", padding: "10px", fontSize: "12px", margin: "10px 0", maxWidth: "600px"}}>
								Det förekommer att Swedbank har en femte siffra i clearingnumret. Vänligen ange
								enbart de fyra första innan bindestrecket. Exempel: 8214-9 ska anges som 8214.
							</p>
						)}

						<div style={{width: "100%", flexDirection: "row", margin: "15px 0 5px 0"}}>
							<EditableField
								name="customer_account_bank_clearingno"
								style={{width: "45%", marginRight: "10px"}}
								label="Clearingnummer"
								value={fields.customer_account_bank_clearingno || ""}
								valid={validFields.customer_account_bank_clearingno}
								onChange={this._onClearingFieldChange}
								onBlur={this._onFieldBlur}
							/>
							<EditableField
								name="customer_account_bank_no"
								style={{width: "45%"}}
								label="Kontonummer"
								value={fields.customer_account_bank_no || ""}
								valid={validFields.customer_account_bank_no}
								onChange={this._onAccountFieldChange}
								onBlur={this._onFieldBlur}
							/>
							<input type="hidden" name="customer_account_clearing_no" value={fields.customer_account_bank_clearingno || ""} />
						</div>
					</React.Fragment>
				)}
			</div>
		);
	}

	_onSelectBankChange = (option) => {
		this.props.onFieldChange.call(this, "customer_account_bank", option.value);
	};

	_onClearingFieldChange = (name, value) => {
		// Remove all non-numbers
		value = value.replace(/[^0-9]+/g, "");

		// Limit clearing numbers to 4 numbers, we'll show a message that says to enter only first four for the
		// banks with longer numbers
		if (value.length >= 4) {
			value = value.substring(0, 4);
		}

		let valid = (this.props.fields.customer_account_bank === '-') ?
			true :
			Validator.validateClearingNumber(value, this.props.fields.customer_account_bank, this.props.availableBanks);

		this.props.onFieldChange.call(this, name, value, valid);
	};

	_onAccountFieldChange = (name, value) => {
		// Remove dashes
		value = value.replace("-", "");
		this.props.onFieldChange.call(this, name, value, value.length > 0);
	};

	_onFieldBlur = (name) => {
		this.props.onFieldBlur.call(this, name, true);
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/nordfk-cob/Fields/collections/CollectionAutogiro.js